
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 5c6.063 0 11 4.937 11 11v11h-8V16c0-1.668-1.332-3-3-3s-3 1.332-3 3v11H5V16C5 9.937 9.937 5 16 5zm0 2c-4.983 0-9 4.017-9 9v5h4v-5c0-2.749 2.251-5 5-5s5 2.251 5 5v5h4v-5c0-4.983-4.017-9-9-9zM7 23v2h4v-2H7zm14 0v2h4v-2h-4z"}})])
          )
        }
      }
    